import { render, staticRenderFns } from "./ImagePerson.vue?vue&type=template&id=9882c1d0&scoped=true&functional=true&"
import script from "./ImagePerson.vue?vue&type=script&lang=js&"
export * from "./ImagePerson.vue?vue&type=script&lang=js&"
import style0 from "./ImagePerson.vue?vue&type=style&index=0&id=9882c1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "9882c1d0",
  null
  
)

export default component.exports